import { render, staticRenderFns } from "./Side-Bar.vue?vue&type=template&id=f61d7ece&scoped=true&"
import script from "./Side-Bar.vue?vue&type=script&lang=js&"
export * from "./Side-Bar.vue?vue&type=script&lang=js&"
import style0 from "./Side-Bar.vue?vue&type=style&index=0&id=f61d7ece&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61d7ece",
  null
  
)

export default component.exports